module.exports = __webpack_public_path__ + "images/sell-review.93841cf9.png";